import { render, staticRenderFns } from "./BannerSwitcher.vue?vue&type=template&id=f01438fe"
import script from "./BannerSwitcher.vue?vue&type=script&lang=js"
export * from "./BannerSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BannerSwitcher.vue?vue&type=style&index=0&id=f01438fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports